import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import {
    Modal, Button, Icon, Grid, Label, Dropdown,
    Table, Dimmer, Loader, Popup, Message
} from "semantic-ui-react";
import {
    getSsmInputs, getSsmDistributors, runsmsmAutomation,
    runSsmAllDistributors, getsmsmAutomationStatus,
    getSsmOutputHistory, downloadSsmAll, downloadSsmRowOutputs, rawFileProcess,
    uploadSsmDistributorFile, getSsmA8Status, createSsmA8File, setSsmA8CreateAllRunning,
    runSsmValidationConsole, downloadSsmValidationConsole
} from "../../../actions/users_action";

const INPUT_FILE_KEYS = [
    { key: "smsmMappingFile",                  label: "Mapping File",                    uploadable: true },
    { key: "smsmCustomChainMaster",           label: "Custom Chain Master",             uploadable: true },
    { key: "smsmChainMaster",                 label: "Chain Master (Console)",           uploadable: false },
    { key: "smsmStoreMasterTemplateHotspot",   label: "Store Master Template - Hotspot", uploadable: true },
    { key: "smsmSellerMasterTemplateHotspot",  label: "Seller Master Template - Hotspot",uploadable: true },
    { key: "smsmStoreMasterTemplateSmartspot", label: "Store Master Template - Smartspot",uploadable: true },
    { key: "smsmSellerMasterTemplateSmartspot","label": "Seller Master Template - Smartspot", uploadable: true },
];

const excludedDistributors = [
    // 'Dummy',
];

class SMSMAutomation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // top-level modal
            automationModalOpen: false,
            // inputs sub-modal
            inputsModalOpen: false,
            smsmInputs: [],
            inputsLoading: false,
            // plan selection
            selectedPlan: '',
            planModalOpen: false,
            // distributor table
            distributors: [],
            distributorsLoading: false,
            // per-row loading
            rowLoading: {},        // { "distributor-location": true }
            rowZipLoading: {},     // { "distributor-location": true }
            rowFileUploadLoading: {}, // { "distributor-location-sm"|"-sell": true }
            // download-all
            downloadAllLoading: false,
            downloadAllUrl: '',
            // auto-poll
            pollInterval: null,
            a8PollInterval: null,
            // validation console
            validationConsoleLoading: false,
            validationConsoleDownloadUrl: '',
            validationConsoleMessage: '',
            // history modal
            historyModalOpen: false,
            historyDistributor: null,
            historyData: [],
            // A8 creation & Validation
            a8CreateModalOpen: false,
            a8Context: null,
            a8Sections: { seller: [], store: [], planning: [] },
            a8Gates: { canCreateStore: false, canCreatePlanning: false },
            a8Loading: false,
            a8CreateLoading: {},
            a8CreateAllLoading: {},  // { seller: bool, store: bool, planning: bool }
            a8CreateAllStop: {},     // set true to abort a running Create All
            a8AutoCreating: {},      // { seller: bool, store: bool, planning: bool } — shows auto-creation in progress
            a8AutoCreationStatus: '', // 'pending', 'running', 'completed', 'failed'

        };
    }

    componentWillUnmount() {
        this._stopPoll();
        this._stopA8Poll();
    }

    componentDidMount() {
        if (this.props.defaultOpen) {
            this.setState({ automationModalOpen: true });
        }
    }

    // ── Open / close ─────────────────────────────────────────────────────────
    open = () => this.setState({ automationModalOpen: true })
    close = () => {
        this._stopPoll();
        this._stopA8Poll();
        this.setState({ automationModalOpen: false, planModalOpen: false, selectedPlan: '' });
        if (this.props.onClose) this.props.onClose();
    }

    // ── Inputs ────────────────────────────────────────────────────────────────
    openInputs = () => {
        this.setState({ inputsModalOpen: true, inputsLoading: true });
        this.props.getSsmInputs(this.props.templateId, {
            onSuccess: (res) => {
                const apiInputs = res.inputs || [];
                const byKey = apiInputs.reduce((acc, item) => {
                    acc[item.key] = item;
                    return acc;
                }, {});

                const normalized = INPUT_FILE_KEYS.map(base => ({
                    ...base,
                    ...(byKey[base.key] || {}),
                }));

                // Keep any additional API-only rows (future-proofing)
                apiInputs.forEach(item => {
                    // Deprecated compatibility key; avoid duplicate Chain Master rows.
                    if (item.key === 'chainMaster') return;
                    if (!normalized.find(n => n.key === item.key)) {
                        normalized.push(item);
                    }
                });

                this.setState({ smsmInputs: normalized, inputsLoading: false });
            },
            onFailure: () => this.setState({ inputsLoading: false }),
        });
    }

    uploadInputFile = (fileKey, file) => {
        this.props.rawFileProcess(file, fileKey, this.props.templateId, {
            onSuccess: () => {
                alert(`${fileKey} uploaded successfully`);
                this.openInputs();   // refresh
            },
            onFailure: () => alert(`Upload failed for ${fileKey}`),
        });
    }

    // ── Plan selection ────────────────────────────────────────────────────────
    selectPlan = (plan) => {
        this.setState({ selectedPlan: plan, planModalOpen: true, distributors: [] });
        this._loadDistributors(plan);
        this._checkExistingConsolidation(plan);
    }

    _checkExistingConsolidation = (plan) => {
        if (!this.props.templateId) return;
        this.props.downloadSsmValidationConsole({
            templateId: this.props.templateId,
            process: plan.toLowerCase()
        }, {
            onSuccess: (res) => {
                if (res.downloadUrl) {
                    this.setState({
                        validationConsoleDownloadUrl: res.downloadUrl,
                        validationConsoleMessage: 'Previous consolidation available',
                        validationConsoleLoading: false
                    });
                }
            },
            onFailure: () => {
                // No previous consolidation found - ignore silently
            }
        });
    }

    closePlanModal = () => {
        this._stopPoll();
        this.setState({
            planModalOpen: false,
            selectedPlan: '',
            validationConsoleLoading: false,
            validationConsoleDownloadUrl: '',
            validationConsoleMessage: ''
        });
    }

    _loadDistributors = (plan) => {
        this.setState({ distributorsLoading: true });
        this.props.getSsmDistributors(this.props.templateId, plan.toLowerCase(), this.props.templateName, {
            onSuccess: (res) => {
                const distributors = res.distributors || [];
                this.setState({ distributors, distributorsLoading: false });
                // Auto-start polling if any row is already Processing
                const hasProcessing = distributors.some(d => d.automationStatus === 'Processing');
                if (hasProcessing) this._startPoll();
            },
            onFailure: () => this.setState({ distributorsLoading: false }),
        });
    }

    // ── Per-row distributor file upload (Store Master / Seller Master) ────────
    uploadDistributorFile = (distributor, location, fileType, file) => {
        // fileType: 'Store Master' or 'Seller Master'
        const uploadKey = `${distributor}-${location}-${fileType === 'Store Master' ? 'sm' : 'sell'}`;
        this.setState(prev => ({ rowFileUploadLoading: { ...prev.rowFileUploadLoading, [uploadKey]: true } }));
        this.props.uploadSsmDistributorFile(
            file, fileType, this.props.templateId, distributor, location, this.state.selectedPlan.toLowerCase(),
            {
                onSuccess: (res) => {
                    this.setState(prev => ({ rowFileUploadLoading: { ...prev.rowFileUploadLoading, [uploadKey]: false } }));
                    // Refresh the row's status + URL in state without full reload
                    this._loadDistributors(this.state.selectedPlan);
                },
                onFailure: () => {
                    this.setState(prev => ({ rowFileUploadLoading: { ...prev.rowFileUploadLoading, [uploadKey]: false } }));
                    alert(`Failed to upload ${fileType}`);
                }
            }
        );
    }

    // ── Polling — only refresh Status fields, not the full table ─────────────
    _startPoll = () => {
        this._stopPoll();
        const id = setInterval(() => {
            if (!this.state.planModalOpen || !this.state.selectedPlan) return;
            // Poll only the rows that are currently Processing
            const processingRows = this.state.distributors.filter(
                row => row.automationStatus === 'Processing'
            );
            if (processingRows.length === 0) {
                // Nothing left processing — stop polling
                this._stopPoll();
                return;
            }
            processingRows.forEach(row => {
                this.props.getsmsmAutomationStatus(
                    this.props.templateId, row.distributor, row.location,
                    this.state.selectedPlan.toLowerCase(),
                    {
                        onSuccess: (res) => {
                            this.setState(prev => ({
                                distributors: prev.distributors.map(d =>
                                    d.distributor === row.distributor && d.location === row.location
                                        ? {
                                            ...d,
                                            automationStatus: res.status,
                                            errorMessage:     res.errorMessage,
                                            newBranches:      res.newBranches || [],
                                            outputs:          res.outputs || d.outputs,
                                        }
                                        : d
                                )
                            }));
                        },
                        onFailure: () => {}
                    }
                );
            });
        }, 10000);
        this.setState({ pollInterval: id });
    }
    _stopPoll = () => {
        if (this.state.pollInterval) {
            clearInterval(this.state.pollInterval);
            this.setState({ pollInterval: null });
        }
    }

    _isA8InFlight = (sections, createAllRunning) => {
        const hasRunningFlag = Object.values(createAllRunning || {}).some(Boolean);
        if (hasRunningFlag) return true;

        const stages = ['seller', 'store', 'planning'];
        return stages.some(stage =>
            (sections?.[stage] || []).some(row => {
                const state = (row?.state || '').toLowerCase();
                return state === 'creating' || state === 'processing';
            })
        );
    }

    _isTransientA8CreateFailure = (err, stage, fileIndex, fallbackSections = null) => {
        const responseStatus = err?.response?.status;
        const responseData = err?.response?.data || {};
        const sections = responseData?.sections || fallbackSections || this.state.a8Sections || {};
        const rowFromResponse = sections?.[stage]?.[fileIndex] || null;
        const rowState = (rowFromResponse?.state || '').toLowerCase();
        const messageText = String(responseData?.message || responseData?.error || err?.message || '').toLowerCase();

        if (responseStatus === 409) return true;
        if (typeof responseStatus === 'number' && responseStatus >= 500) return true;
        if (!responseStatus && (err?.code === 'ECONNABORTED' || messageText.includes('network error') || messageText.includes('timeout'))) return true;
        if (rowState === 'creating' || rowState === 'processing') return true;
        if (messageText.includes('please wait') || messageText.includes('processing')) return true;

        return false;
    }

    _refreshA8Status = (options = {}) => {
        const { a8Context } = this.state;
        if (!a8Context) return;

        this.props.getSsmA8Status(
            this.props.templateId,
            a8Context.distributor,
            a8Context.location,
            a8Context.process,
            {
                onSuccess: (res) => {
                    const sections = res.sections || { seller: [], store: [], planning: [] };
                    const runningFlags = res.createAllRunning || {};
                    const inFlight = this._isA8InFlight(sections, runningFlags);

                    this.setState(prev => ({
                        a8Context: { ...prev.a8Context, ...(res.context || {}) },
                        a8Sections: sections,
                        a8Gates: res.gates || prev.a8Gates,
                        a8CreateAllLoading: runningFlags,
                        a8AutoCreating: inFlight ? runningFlags : {},
                        a8AutoCreationStatus: inFlight ? 'running' : '',
                    }), () => {
                        if (!inFlight) {
                            this._stopA8Poll();
                        } else if (options.ensurePolling) {
                            this._startA8Poll();
                        }
                    });
                },
                onFailure: () => {
                    if (options.stopOnFailure) {
                        this._stopA8Poll();
                    }
                }
            }
        );
    }

    _startA8Poll = () => {
        if (this.state.a8PollInterval) return;
        const id = setInterval(() => {
            if (!this.state.a8CreateModalOpen) {
                this._stopA8Poll();
                return;
            }
            this._refreshA8Status();
        }, 8000);
        this.setState({ a8PollInterval: id });
    }

    _stopA8Poll = () => {
        if (this.state.a8PollInterval) {
            clearInterval(this.state.a8PollInterval);
            this.setState({ a8PollInterval: null });
        }
    }

    // ── Start single ─────────────────────────────────────────────────────────
    startOne = (distributor, location) => {
        // Check if validation console is running
        if (this.state.validationConsoleLoading) {
            alert('Please try after the consolidation is completed.');
            return;
        }

        const rowKey = `${distributor}-${location}`;
        this.setState(prev => ({ rowLoading: { ...prev.rowLoading, [rowKey]: true } }));
        this.props.runsmsmAutomation({
            templateId:   this.props.templateId,
            templateName: this.props.templateName || '',
            distributor, location,
            process: this.state.selectedPlan.toLowerCase()
        }, {
            onSuccess: () => {
                this.setState(prev => ({ rowLoading: { ...prev.rowLoading, [rowKey]: false } }));
                this._loadDistributors(this.state.selectedPlan);
                this._startPoll();
            },
            onFailure: (err) => {
                this.setState(prev => ({ rowLoading: { ...prev.rowLoading, [rowKey]: false } }));
                alert(err?.response?.data?.error || 'Failed to start automation');
            }
        });
    }

    // ── Run all ───────────────────────────────────────────────────────────────
    runAll = () => {
        if (!this.state.selectedPlan) {
            alert('Please select a plan first');
            return;
        }
        // Check if validation console is running
        if (this.state.validationConsoleLoading) {
            alert('Please try after the consolidation is completed.');
            return;
        }
        if (!window.confirm(`Run all distributors for ${this.state.selectedPlan}?`)) return;
        this.props.runSsmAllDistributors({
            templateId:   this.props.templateId,
            templateName: this.props.templateName || '',
            process: this.state.selectedPlan.toLowerCase()
        }, {
            onSuccess: (res) => {
                alert(`Queued ${res.queued}, skipped ${res.skipped}`);
                this._loadDistributors(this.state.selectedPlan);
                this._startPoll();
            },
            onFailure: () => alert('Failed to queue all distributors'),
        });
    }

    // ── Download all ─────────────────────────────────────────────────────────
    downloadAll = () => {
        this.setState({ downloadAllLoading: true });
        this.props.downloadSsmAll({
            templateId: this.props.templateId,
            process: this.state.selectedPlan.toLowerCase()
        }, {
            onSuccess: (res) => {
                this.setState({ downloadAllLoading: false });
                alert(`Zip job queued. Job ID: ${res.jobId}`);
            },
            onFailure: () => this.setState({ downloadAllLoading: false }),
        });
    }

    // ── Validation Console ───────────────────────────────────────────────────
    runValidationConsole = () => {
        if (!this.state.selectedPlan) {
            alert('Please select a plan first');
            return;
        }

        // Check if any workings are currently processing
        const hasProcessingWorkings = this.state.distributors.some(
            d => d.automationStatus === 'Processing'
        );
        if (hasProcessingWorkings) {
            alert('Please try after the workings completed.');
            return;
        }

        this.setState({ validationConsoleLoading: true, validationConsoleMessage: '' });
        this.props.runSsmValidationConsole({
            templateId: this.props.templateId,
            templateName: this.props.templateName || '',
            process: this.state.selectedPlan.toLowerCase()
        }, {
            onSuccess: (res) => {
                this.setState({
                    validationConsoleLoading: false,
                    validationConsoleDownloadUrl: res.downloadUrl || '',
                    validationConsoleMessage: res.message || 'Consolidation completed'
                });
                alert(res.message || 'Validation console consolidation completed');
            },
            onFailure: (err) => {
                this.setState({ validationConsoleLoading: false });
                const msg = err?.response?.data?.error || 'Failed to run validation console';
                this.setState({ validationConsoleMessage: msg });
                alert(msg);
            }
        });
    }

    downloadValidationConsole = () => {
        if (!this.state.selectedPlan) {
            alert('Please select a plan first');
            return;
        }
        if (!this.state.validationConsoleDownloadUrl) {
            // Try to fetch the download URL first
            this.props.downloadSsmValidationConsole({
                templateId: this.props.templateId,
                process: this.state.selectedPlan.toLowerCase()
            }, {
                onSuccess: (res) => {
                    if (res.downloadUrl) {
                        window.open(res.downloadUrl, '_blank');
                        this.setState({ validationConsoleDownloadUrl: res.downloadUrl });
                    } else {
                        alert('No consolidated file found. Run consolidation first.');
                    }
                },
                onFailure: (err) => {
                    alert(err?.response?.data?.error || 'Failed to get download URL');
                }
            });
        } else {
            window.open(this.state.validationConsoleDownloadUrl, '_blank');
        }
    }

    // ── Download single row outputs as zip ────────────────────────────────────
    downloadRowOutputs = (distributor, location, outputs) => {
        const rowKey = `${distributor}-${location}`;
        this.setState(prev => ({ rowZipLoading: { ...prev.rowZipLoading, [rowKey]: true } }));
        this.props.downloadSsmRowOutputs({
            templateId: this.props.templateId,
            distributor,
            location,
            process: this.state.selectedPlan.toLowerCase()
        }, {
            onSuccess: (res) => {
                this.setState(prev => ({ rowZipLoading: { ...prev.rowZipLoading, [rowKey]: false } }));
                if (res.downloadUrl) {
                    window.open(res.downloadUrl, '_blank');
                } else {
                    alert(`Zip job queued. Job ID: ${res.jobId}`);
                }
            },
            onFailure: () => {
                this.setState(prev => ({ rowZipLoading: { ...prev.rowZipLoading, [rowKey]: false } }));
                alert('Failed to download outputs');
            }
        });
    }

    // ── History — disabled, kept for reference ───────────────────────────────
    // openHistory = (distributor, location) => {
    //     this.setState({ historyModalOpen: true, historyDistributor: `${distributor} - ${location}`, historyData: [] });
    //     this.props.getSsmOutputHistory(
    //         this.props.templateId, distributor, location,
    //         this.state.selectedPlan.toLowerCase(),
    //         {
    //             onSuccess: (res) => this.setState({ historyData: res.history || [] }),
    //             onFailure: () => {},
    //         }
    //     );
    // }

    // ----------- A8 Create & Validation ---------------
    openA8Create = (row) => {
        const outputs = row.outputs || {};
        if (outputs.errorReport) {
            alert('Kindly check the error file.');
            return;
        }

        const context = {
            templateName: this.props.templateName || '',
            distributor: row.distributor,
            location: row.location,
            process: this.state.selectedPlan.toLowerCase(),
            month: '',
        };
        this.setState({ a8CreateModalOpen: true, a8Context: context, a8Loading: true }, () => {
            this.props.getSsmA8Status(
                this.props.templateId,
                row.distributor,
                row.location,
                this.state.selectedPlan.toLowerCase(),
                {
                    onSuccess: (res) => {
                        const autoRunning = res.createAllRunning || {};
                        const sections = res.sections || { seller: [], store: [], planning: [] };
                        const isAutoRunning = this._isA8InFlight(sections, autoRunning);
                        
                        this.setState({
                            a8Loading: false,
                            a8Context: { ...context, ...(res.context || {}) },
                            a8Sections: sections,
                            a8Gates: res.gates || { canCreateStore: false, canCreatePlanning: false },
                            a8CreateAllLoading: res.createAllRunning || {},
                            a8AutoCreating: isAutoRunning ? autoRunning : {},
                            a8AutoCreationStatus: isAutoRunning ? 'running' : '',
                        }, () => {
                            if (isAutoRunning) {
                                this._startA8Poll();
                            } else {
                                this._stopA8Poll();
                            }
                        });
                    },
                    onFailure: (err) => {
                        this.setState({ a8Loading: false });
                        alert(err?.response?.data?.error || 'Failed to load A8 status');
                    }
                }
            );
        });
    }

    closeA8CreateModal = () => {
        this._stopA8Poll();
        this.setState({
            a8CreateModalOpen: false,
            a8Context: null,
            a8Sections: { seller: [], store: [], planning: [] },
            a8Gates: { canCreateStore: false, canCreatePlanning: false },
            a8Loading: false,
            a8CreateLoading: {},
            a8CreateAllLoading: {},
            a8CreateAllStop: {},
            a8AutoCreating: {},
            a8AutoCreationStatus: '',
        });
    }

    // ── Create All — sequential, tolerant to transient A8/network errors ────
    createAllA8Section = async (stage) => {
        const { a8Context, a8Gates, a8Sections } = this.state;
        if (!a8Context) return;

        if (stage === 'store' && !a8Gates.canCreateStore) {
            alert('Store creation is enabled only after all Seller files are successful.');
            return;
        }
        if (stage === 'planning' && !a8Gates.canCreatePlanning) {
            alert('Plan creation is enabled only after all Store files are successful.');
            return;
        }

        const files = a8Sections?.[stage] || [];
        const pending = files
            .map((f, idx) => ({ idx, state: (f.state || 'pending').toLowerCase() }))
            .filter(f => f.state !== 'success');

        if (pending.length === 0) {
            alert(`All ${stage} files are already successful.`);
            return;
        }

        // Mark running in DB and local state
        const _setRunning = (running) => {
            this.props.setSsmA8CreateAllRunning({
                templateId:  this.props.templateId,
                distributor: a8Context.distributor,
                location:    a8Context.location,
                process:     a8Context.process,
                stage,
                running,
            }, { onSuccess: () => {}, onFailure: () => {} });
        };

        _setRunning(true);
        this.setState(prev => ({
            a8CreateAllLoading: { ...prev.a8CreateAllLoading, [stage]: true },
            a8CreateAllStop:    { ...prev.a8CreateAllStop,    [stage]: false },
            a8AutoCreationStatus: 'running',
        }));
        this._startA8Poll();

        for (let i = 0; i < pending.length; i++) {
            const { idx } = pending[i];

            // Check local stop flag
            if (this.state.a8CreateAllStop?.[stage]) break;

            const ok = await new Promise(resolve => {
                this.setState(prev => ({ a8CreateLoading: { ...prev.a8CreateLoading, [`${stage}-${idx}`]: true } }));
                this.props.createSsmA8File({
                    templateId:  this.props.templateId,
                    distributor: a8Context.distributor,
                    location:    a8Context.location,
                    process:     a8Context.process,
                    stage,
                    fileIndex:   idx,
                    appName:     a8Context.process,
                    month:       a8Context.month,
                }, {
                    onSuccess: (res) => {
                        this.setState(prev => ({
                            a8CreateLoading: { ...prev.a8CreateLoading, [`${stage}-${idx}`]: false },
                            a8Sections: res.sections || prev.a8Sections,
                            a8Gates:    res.gates    || prev.a8Gates,
                        }));
                        resolve(res.ok !== false);
                    },
                    onFailure: (err) => {
                        const responseData = err?.response?.data || {};
                        const transient = this._isTransientA8CreateFailure(
                            err,
                            stage,
                            idx,
                            responseData.sections || this.state.a8Sections
                        );

                        this.setState(prev => ({
                            a8CreateLoading: { ...prev.a8CreateLoading, [`${stage}-${idx}`]: false },
                            a8Sections: responseData.sections || prev.a8Sections,
                            a8Gates:    responseData.gates    || prev.a8Gates,
                        }));

                        if (transient) {
                            resolve(true);
                            return;
                        }
                        resolve(false);
                    }
                });
            });

            if (!ok) {
                alert(`Upload All stopped at file ${idx + 1} due to an error.`);
                break;
            }
        }

        // Clear running state in DB and locally
        _setRunning(false);
        this.setState(prev => ({
            a8CreateAllLoading: { ...prev.a8CreateAllLoading, [stage]: false },
            a8CreateAllStop:    { ...prev.a8CreateAllStop,    [stage]: false },
        }));
        this._refreshA8Status({ ensurePolling: true });
    }

    createA8File = (stage, fileIndex) => {
        const key = `${stage}-${fileIndex}`;
        if (this.state.a8CreateLoading[key]) return;

        const { a8Context, a8Gates } = this.state;
        if (!a8Context) return;

        if (stage === 'store' && !a8Gates.canCreateStore) {
            alert('Store creation is enabled only after all Seller files are successful.');
            return;
        }
        if (stage === 'planning' && !a8Gates.canCreatePlanning) {
            alert('Plan creation is enabled only after all Store files are successful.');
            return;
        }

        this.setState(prev => ({ a8CreateLoading: { ...prev.a8CreateLoading, [key]: true } }));

        this.props.createSsmA8File({
            templateId: this.props.templateId,
            distributor: a8Context.distributor,
            location: a8Context.location,
            process: a8Context.process,
            stage,
            fileIndex,
            appName: a8Context.process,
            month: a8Context.month,
        }, {
            onSuccess: (res) => {
                console.log('res - createSsmA8File : ', res)
                this.setState(prev => ({
                    a8CreateLoading: { ...prev.a8CreateLoading, [key]: false },
                    a8Sections: res.sections || prev.a8Sections,
                    a8Gates: res.gates || prev.a8Gates,
                }), () => {
                    this._refreshA8Status({ ensurePolling: true });
                });
            },
            onFailure: (err) => {
                const responseData = err?.response?.data || {};
                const transient = this._isTransientA8CreateFailure(err, stage, fileIndex, responseData.sections || this.state.a8Sections);

                this.setState(prev => ({
                    a8CreateLoading: { ...prev.a8CreateLoading, [key]: false },
                    a8Sections: responseData.sections || prev.a8Sections,
                    a8Gates: responseData.gates || prev.a8Gates,
                }), () => {
                    this._refreshA8Status({ ensurePolling: true });
                });

                // Backend can return non-2xx while the upstream job is still settling.
                // Avoid a false failure alert when the row is actually in-progress.
                if (transient) {
                    return;
                }

                alert(responseData.error || responseData.message || 'A8 create failed');
            }
        });
    }

    // ── Download completed A8 files as ZIP ─────────────────────────────────
    _downloadA8Section = async (stage, completedFiles) => {
        if (!completedFiles || completedFiles.length === 0) {
            alert('No completed files to download.');
            return;
        }

        try {
            const { a8Context } = this.state;
            const fileUrls = completedFiles
                .filter(f => f.outputDownloadUrl)
                .map(f => ({ url: f.outputDownloadUrl, name: f.outputFileName || `${stage}_${Date.now()}.xlsx` }));

            if (fileUrls.length === 0) {
                alert('No download URLs available for completed files.');
                return;
            }

            // Download files sequentially and create a blob for ZIP-like download
            const links = fileUrls.map((file, idx) => ({
                href: file.url,
                download: `${stage}_${a8Context?.location}_${idx + 1}.xlsx`
            }));

            // If only one file, download directly
            if (links.length === 1) {
                const link = document.createElement('a');
                link.href = links[0].href;
                link.download = links[0].download;
                link.click();
                return;
            }

            // For multiple files, trigger downloads sequentially
            for (const link of links) {
                const anchor = document.createElement('a');
                anchor.href = link.href;
                anchor.download = link.download;
                anchor.click();
                // Small delay between downloads to avoid browser throttling
                await new Promise(resolve => setTimeout(resolve, 500));
            }

            alert(`Downloaded ${links.length} completed ${stage} file(s).`);
        } catch (err) {
            console.error('Download error:', err);
            alert('Failed to download files. Please try again.');
        }
    }



    // ── Status badge ──────────────────────────────────────────────────────────
    _badge = (status) => {
        const map = {
            Completed: 'green', Processing: 'yellow',
            Failed: 'red', Pending: 'grey'
        };
        return <Label circular color={map[status] || 'grey'} size='tiny'>{status || 'Pending'}</Label>;
    }

    _a8StatusBadge = (state) => {
        const normalized = (state || 'pending').toLowerCase();
        if (normalized === 'success') {
            return <Label circular color='green' size='tiny'>Success</Label>;
        }
        if (normalized === 'error') {
            return <Label circular color='red' size='tiny'>Error</Label>;
        }
        if (normalized === 'creating' || normalized === 'processing') {
            return <Label circular color='yellow' size='tiny'>Processing</Label>;
        }
        return <Label circular color='grey' size='tiny'>Pending</Label>;
    }

    // ── Source badge (Phase 6) ────────────────────────────────────────────────
    // _sourceBadge = (source) => {
    //     if (!source) return null;
    //     const isUser = source === 'user';
    //     return (
    //         <Popup
    //             trigger={
    //                 <Label size='mini' color={isUser ? 'blue' : 'grey'} style={{ marginLeft: 4 }}>
    //                     {isUser ? 'user' : 'client'}
    //                 </Label>
    //             }
    //             content={isUser ? 'Using admin-uploaded file (override)' : 'Using client-uploaded file'}
    //         />
    //     );
    // }

    // ── Download buttons ──────────────────────────────────────────────────────
    _dlBtn = (url, label) => url
        ? <a href={url} target="_blank" rel="noreferrer">
              <Button size='mini' basic color='blue' icon='download' content={label} />
          </a>
        : <Button size='mini' basic color='grey' disabled icon='download' content={label} />;

    _dlList = (urls, label) => {
        if (!urls || urls.length === 0) return <span style={{ color: '#aaa', fontSize: '0.8em' }}>—</span>;
        return urls.map((url, i) => (
            <a key={i} href={url} target="_blank" rel="noreferrer" style={{ marginRight: 4 }}>
                <Button size='mini' basic color='blue' icon='download' content={`${label} ${i + 1}`} />
            </a>
        ));
    }

    render() {
        const {
            automationModalOpen, inputsModalOpen, smsmInputs, inputsLoading,
            selectedPlan, planModalOpen, distributors, distributorsLoading,
            rowLoading, downloadAllLoading, historyModalOpen, historyDistributor, historyData
        } = this.state;

        const planOptions = [
            { key: 'Hotspot', value: 'Hotspot', text: 'Hotspot' },
            { key: 'Smartspot', value: 'Smartspot', text: 'Smartspot' },
        ];

        return (
            <>
                {/* ── Trigger button — only shown when not driven by parent ── */}
                {!this.props.defaultOpen && (
                    <Button basic color='blue' onClick={this.open} icon='settings'
                        content='StoreMaster / SellerMaster' />
                )}

                {/* ── Main Automation Modal ────────────────────────────────── */}
                <Modal open={automationModalOpen} onClose={this.close} size='small'>
                    <Modal.Header>
                        <Icon name='cogs' color='blue' /> StoreMaster / SellerMaster Automation
                        <Icon name='close' style={{ float: 'right', cursor: 'pointer' }} onClick={this.close} />
                    </Modal.Header>
                    <Modal.Content>
                        <div style={{ display: 'flex', gap: 16, alignItems: 'center', flexWrap: 'wrap' }}>
                            <Button basic color='teal' icon='folder open' content='Inputs'
                                onClick={this.openInputs} />
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <span style={{ fontWeight: 'bold' }}>Select Plan:</span>
                                <Dropdown placeholder='Select Plan' selection options={planOptions}
                                    value={selectedPlan}
                                    onChange={(e, { value }) => this.selectPlan(value)} />
                            </div>
                        </div>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={this.close}>Close</Button>
                    </Modal.Actions>
                </Modal>

                {/* ── Inputs Modal ─────────────────────────────────────────── */}
                <Modal open={inputsModalOpen} onClose={() => this.setState({ inputsModalOpen: false })} size='small'>
                    <Modal.Header>
                        <Icon name='upload' color='teal' /> Input Files
                        <Icon name='close' style={{ float: 'right', cursor: 'pointer' }}
                            onClick={() => this.setState({ inputsModalOpen: false })} />
                    </Modal.Header>
                    <Modal.Content>
                        {inputsLoading ? <Dimmer active inverted><Loader>Loading...</Loader></Dimmer> : null}
                        <Table basic='very' compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>File</Table.HeaderCell>
                                    <Table.HeaderCell>Status</Table.HeaderCell>
                                    <Table.HeaderCell>Actions</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {(() => {
                                    const rows = smsmInputs.length
                                        ? smsmInputs
                                        : INPUT_FILE_KEYS.map(k => ({ ...k, status: 'Yet to Upload', downloadUrl: null }));

                                    const activeChainRow = rows.find(r => r.key === 'smsmChainMaster') || {};
                                    const activeSource = String(activeChainRow.source || '').toLowerCase();

                                    return rows.map(inp => {
                                        const isUsedCustom = inp.key === 'smsmCustomChainMaster' && activeSource.includes('custom');
                                        const isUsedConsole = inp.key === 'smsmChainMaster' && !activeSource.includes('custom');
                                        const isUsed = isUsedCustom || isUsedConsole;

                                        return (
                                            <Table.Row key={inp.key}>
                                                <Table.Cell>
                                                    <strong>{inp.label}</strong>
                                                    {isUsed && (
                                                        <Label color='blue' size='mini' style={{ marginLeft: 8 }}>
                                                            Used
                                                        </Label>
                                                    )}
                                                    {inp.key === 'smsmChainMaster' && !!activeChainRow.source && !activeSource.includes('custom') && (
                                                        <Label basic color='grey' size='mini' style={{ marginLeft: 8 }}>
                                                            {activeSource.includes('raw')
                                                                ? 'From Console Chain Master'
                                                                : `Source: ${activeChainRow.source}`}
                                                        </Label>
                                                    )}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    <Label color={inp.status === 'Available' ? 'green' : 'red'} size='tiny'>
                                                        {inp.status}
                                                    </Label>
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {inp.uploadable !== false && (
                                                        <label style={{ cursor: 'pointer', marginRight: 8 }}>
                                                            <Icon name='upload' color='orange' size='large' />
                                                            <input type='file' accept='.xlsx' style={{ display: 'none' }}
                                                                onChange={e => {
                                                                    if (e.target.files[0]) this.uploadInputFile(inp.key, e.target.files[0]);
                                                                    e.target.value = '';
                                                                }} />
                                                        </label>
                                                    )}
                                                    {inp.downloadUrl && (
                                                        <a href={inp.downloadUrl} target='_blank' rel='noreferrer'>
                                                            <Icon name='arrow circle down' color='green' size='large' style={{ cursor: 'pointer' }} />
                                                        </a>
                                                    )}
                                                </Table.Cell>
                                            </Table.Row>
                                        );
                                    });
                                })()}
                            </Table.Body>
                        </Table>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={() => this.setState({ inputsModalOpen: false })}>Close</Button>
                    </Modal.Actions>
                </Modal>

                {/* ── Plan Modal (distributor table) ───────────────────────── */}
                <Modal open={planModalOpen} onClose={this.closePlanModal} size='fullscreen'>
                    <Modal.Header>
                        <Icon name='play circle' color='blue' /> {selectedPlan} — StoreMaster / SellerMaster
                        <Icon name='close' style={{ float: 'right', cursor: 'pointer' }} onClick={this.closePlanModal} />
                    </Modal.Header>
                    <Modal.Content scrolling>
                        {/* ── Store Master Validation Console Section ────────────────── */}
                        <div style={{
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            padding: '16px',
                            marginBottom: '20px',
                            backgroundColor: '#fafafa'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', marginBottom: 8 }}>
                                <Icon name='check circle' color='teal' size='large' />
                                <div>
                                    <div style={{ fontWeight: 'bold', fontSize: '1.1em' }}>Store Master Validation Console</div>
                                    <div style={{ color: '#666', fontSize: '0.85em' }}>
                                        Consolidates StoreMaster_Validated reports from all distributors with completed A8 Audit Planning uploads.
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
                                <Button
                                    basic
                                    color='teal'
                                    icon='play'
                                    content={this.state.validationConsoleMessage && this.state.validationConsoleDownloadUrl ? 'Restart' : 'Start'}
                                    loading={this.state.validationConsoleLoading}
                                    onClick={this.runValidationConsole}
                                />
                                <Button
                                    basic
                                    color='blue'
                                    icon='download'
                                    content='Download'
                                    disabled={!this.state.validationConsoleDownloadUrl}
                                    onClick={this.downloadValidationConsole}
                                />
                                {this.state.validationConsoleMessage && (
                                    <Label color='green' size='small' style={{ marginLeft: 8 }}>
                                        {this.state.validationConsoleMessage}
                                    </Label>
                                )}
                            </div>
                        </div>

                        {distributorsLoading
                            ? <Dimmer active inverted><Loader>Loading distributors...</Loader></Dimmer>
                            : (
                            <Table celled compact>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>Distributor</Table.HeaderCell>
                                        <Table.HeaderCell>Location</Table.HeaderCell>
                                        <Table.HeaderCell>Store Master</Table.HeaderCell>
                                        <Table.HeaderCell>Seller Master</Table.HeaderCell>
                                        <Table.HeaderCell>Status</Table.HeaderCell>
                                        <Table.HeaderCell>Workings</Table.HeaderCell>
                                        <Table.HeaderCell>Output</Table.HeaderCell>
                                        <Table.HeaderCell>Error Report</Table.HeaderCell>
                                        <Table.HeaderCell>A8 Process</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {distributors
                                    .filter(row => !excludedDistributors.includes(row.distributor))
                                    .map(row => {
                                        const rowKey = `${row.distributor}-${row.location}`;
                                        const loading = rowLoading[rowKey];
                                        const zipLoading = this.state.rowZipLoading[rowKey];
                                        const outputs = row.outputs || {};
                                        const hasOutputs = (outputs.storeMaster && outputs.storeMaster.length > 0)
                                            || (outputs.sellerMaster && outputs.sellerMaster.length > 0)
                                            || (outputs.planning && outputs.planning.length > 0)
                                            || outputs.storeMasterValidated;
                                        return (
                                            <Table.Row key={rowKey}>
                                                <Table.Cell><strong>{row.distributor}</strong></Table.Cell>
                                                <Table.Cell>{row.location}</Table.Cell>
                                                {/* ── Store Master cell ── */}
                                                <Table.Cell>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                                        <Label color={row.storeMasterStatus === 'Available' ? 'green' : 'red'} size='tiny'>
                                                            {row.storeMasterStatus}
                                                        </Label>
                                                        {/*{this._sourceBadge(row.storeMasterSource)}*/}
                                                        {row.storeMasterUrl && (
                                                            <a href={row.storeMasterUrl} target='_blank' rel='noreferrer'>
                                                                <Icon name='download' color='blue' style={{ cursor: 'pointer' }} title='Download Store Master' />
                                                            </a>
                                                        )}
                                                        <label style={{ cursor: 'pointer', margin: 0 }} title='Upload Store Master'>
                                                            {this.state.rowFileUploadLoading[`${rowKey}-sm`]
                                                                ? <Icon name='spinner' loading color='grey' />
                                                                : <Icon name='upload' color={row.storeMasterStatus === 'Available' ? 'grey' : 'orange'} />
                                                            }
                                                            <input type='file' accept='.xlsx' style={{ display: 'none' }}
                                                                onChange={e => {
                                                                    if (e.target.files[0]) this.uploadDistributorFile(row.distributor, row.location, 'Store Master', e.target.files[0]);
                                                                    e.target.value = '';
                                                                }} />
                                                        </label>
                                                    </div>
                                                </Table.Cell>
                                                {/* ── Seller Master cell ── */}
                                                <Table.Cell>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                                        <Label color={row.sellerMasterStatus === 'Available' ? 'green' : 'orange'} size='tiny'>
                                                            {row.sellerMasterStatus}
                                                        </Label>
                                                        {/*{this._sourceBadge(row.sellerMasterSource)}*/}
                                                        {row.sellerMasterUrl && (
                                                            <a href={row.sellerMasterUrl} target='_blank' rel='noreferrer'>
                                                                <Icon name='download' color='blue' style={{ cursor: 'pointer' }} title='Download Seller Master' />
                                                            </a>
                                                        )}
                                                        <label style={{ cursor: 'pointer', margin: 0 }} title='Upload Seller Master'>
                                                            {this.state.rowFileUploadLoading[`${rowKey}-sell`]
                                                                ? <Icon name='spinner' loading color='grey' />
                                                                : <Icon name='upload' color={row.sellerMasterStatus === 'Available' ? 'grey' : 'orange'} />
                                                            }
                                                            <input type='file' accept='.xlsx' style={{ display: 'none' }}
                                                                onChange={e => {
                                                                    if (e.target.files[0]) this.uploadDistributorFile(row.distributor, row.location, 'Seller Master', e.target.files[0]);
                                                                    e.target.value = '';
                                                                }} />
                                                        </label>
                                                    </div>
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {this._badge(row.automationStatus)}
                                                    {row.errorMessage && (
                                                        <Popup
                                                            trigger={<Icon name='warning sign' color='red' style={{ marginLeft: 6, cursor: 'pointer' }} />}
                                                            content={row.errorMessage}
                                                        />
                                                    )}
                                                    {row.newBranches && row.newBranches.length > 0 && (
                                                        <Popup
                                                            trigger={<Icon name='info circle' color='orange' style={{ marginLeft: 4, cursor: 'pointer' }} />}
                                                            content={`New branches: ${row.newBranches.join(', ')}`}
                                                            wide
                                                        />
                                                    )}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {/* Disabled while Processing — enabled only on Completed, Failed, or Pending */}
                                                    <Button size='mini' basic
                                                        color={row.automationStatus === 'Completed' || row.automationStatus === 'Failed' ? 'orange' : 'green'}
                                                        icon={loading || row.automationStatus === 'Processing' ? 'spinner' : 'play'}
                                                        loading={loading}
                                                        disabled={
                                                            loading ||
                                                            row.storeMasterStatus !== 'Available' ||
                                                            row.automationStatus === 'Processing'
                                                        }
                                                        content={row.automationStatus === 'Completed' || row.automationStatus === 'Failed' ? 'Re-Start' : 'Start'}
                                                        onClick={() => this.startOne(row.distributor, row.location)}
                                                    />
                                                </Table.Cell>
                                                {/* Single Output column — downloads zip of all output files */}
                                                <Table.Cell>
                                                    {hasOutputs ? (
                                                        <Button size='mini' basic color='blue'
                                                            icon={zipLoading ? 'spinner' : 'download'}
                                                            loading={zipLoading}
                                                            content='Download (Zip)'
                                                            onClick={() => this.downloadRowOutputs(row.distributor, row.location, outputs)}
                                                        />
                                                    ) : (
                                                        <span style={{ color: '#aaa', fontSize: '0.8em' }}>Not Found</span>
                                                    )}
                                                </Table.Cell>
                                                <Table.Cell>{this._dlBtn(outputs.errorReport, 'Error')}</Table.Cell>
                                                {/* <Table.Cell>
                                                    <Button size='mini' basic color='blue' icon='history'
                                                        onClick={() => this.openHistory(row.distributor, row.location)} />
                                                </Table.Cell> */}
                                                <Table.Cell>
                                                    <Popup
                                                        content={outputs.errorReport
                                                            ? 'Kindly check the error file before proceeding to A8 process.'
                                                            : 'Open A8 process details'}
                                                        trigger={
                                                            <Button
                                                                size='mini'
                                                                basic
                                                                color='blue'
                                                                content='View'
                                                                onClick={() => this.openA8Create(row)}
                                                            />
                                                        }
                                                    />
                                                </Table.Cell>
                                            </Table.Row>
                                        );
                                    })}
                                    {distributors.length === 0 && (
                                        <Table.Row>
                                            <Table.Cell colSpan={9} textAlign='center' style={{ color: '#aaa' }}>
                                                No distributors found.
                                            </Table.Cell>
                                        </Table.Row>
                                    )}
                                </Table.Body>
                            </Table>
                        )}
                    </Modal.Content>
                    <Modal.Actions style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', gap: 8 }}>
                            {/*<Button basic color='green' icon='play' content='Run All Distributors' onClick={this.runAll} />
                             <Button basic color='blue' icon='download' loading={downloadAllLoading}
                                content='Download All (Zip)' onClick={this.downloadAll} /> */}
                        </div>
                        <Button onClick={this.closePlanModal}>Close</Button>
                    </Modal.Actions>
                </Modal>

                {/* ── A8 Modal ─────────────────────────────────────────────── */}
                <Modal open={this.state.a8CreateModalOpen} onClose={this.closeA8CreateModal} size='large'>
                    <Modal.Header>
                        <Icon name='settings' color='blue' /> A8 Process
                        {this.state.a8AutoCreationStatus === 'running' && (
                            <Popup
                                trigger={<Label style={{ marginLeft: 12 }} color='orange' icon='spinner' content='Auto-creating files...' />}
                                content='Files are being created automatically by the system after SMSM completion.'
                            />
                        )}
                        <Icon name='close' style={{ float: 'right', cursor: 'pointer' }} onClick={this.closeA8CreateModal} />
                    </Modal.Header>
                    <Modal.Content scrolling>
                        {this.state.a8Loading ? (
                            <Dimmer active inverted><Loader>Loading A8 details...</Loader></Dimmer>
                        ) : (
                            <>
                                <div style={{ marginBottom: 12 }}>
                                    <div><strong>Selected Template:</strong> {this.state.a8Context?.templateName || '-'}</div>
                                    <div><strong>Distributor - Location:</strong> {this.state.a8Context?.distributor || '-'} - {this.state.a8Context?.location || '-'}</div>
                                    <div><strong>Process:</strong> {(this.state.a8Context?.process || '-').toString()}</div>
                                </div>

                                {[{ key: 'seller', title: 'Seller Master Upload' }, { key: 'store', title: 'Store Master Upload' }, { key: 'planning', title: 'Audit Planning Upload' }].map((section, sectionIndex) => {
                                    const files = this.state.a8Sections?.[section.key] || [];
                                    const sectionLocked = (section.key === 'store' && !this.state.a8Gates.canCreateStore)
                                        || (section.key === 'planning' && !this.state.a8Gates.canCreatePlanning);
                                    const isCreateAllRunning = Object.values(this.state.a8CreateAllLoading).some(v => v);
                                    const isSingleUploadRunning = Object.values(this.state.a8CreateLoading || {}).some(v => v);
                                    const isAnyUploadRunning = isCreateAllRunning || isSingleUploadRunning
                                        || this._isA8InFlight(this.state.a8Sections, this.state.a8CreateAllLoading);
                                    const completedFiles = files.filter(f => (f.state || 'pending').toLowerCase() === 'success');
                                    const hasCompletedFiles = completedFiles.length > 0;

                                    return (
                                        <div key={section.key}>
                                            {/* Horizontal divider between sections */}
                                            {sectionIndex > 0 && (
                                                <div style={{ borderTop: '2px solid #ddd', margin: '20px 0 16px 0' }} />
                                            )}
                                            
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                                                <h4 style={{ margin: 0 }}>{section.title}</h4>
                                                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                                    {!sectionLocked && files.length > 0 && (
                                                        <>
                                                            {this.state.a8CreateAllLoading[section.key]
                                                                ? <Button size='mini' basic color='red' icon='stop' content='Stop'
                                                                    onClick={() => {
                                                                        this.props.setSsmA8CreateAllRunning({
                                                                            templateId:  this.props.templateId,
                                                                            distributor: this.state.a8Context?.distributor,
                                                                            location:    this.state.a8Context?.location,
                                                                            process:     this.state.a8Context?.process,
                                                                            stage:       section.key,
                                                                            running:     false,
                                                                        }, { onSuccess: () => {}, onFailure: () => {} });
                                                                        this.setState(prev => ({
                                                                            a8CreateAllStop:    { ...prev.a8CreateAllStop,    [section.key]: true },
                                                                            a8CreateAllLoading: { ...prev.a8CreateAllLoading, [section.key]: false },
                                                                        }));
                                                                    }} />
                                                                : <Button size='mini' basic color='teal' icon='play'
                                                                    content={`Upload All (${files.filter(f => (f.state || 'pending') !== 'success').length} pending)`}
                                                                    disabled={isAnyUploadRunning}
                                                                    onClick={() => {
                                                                        // Collision detection: warn if another stage is creating
                                                                        if (isCreateAllRunning && !this.state.a8CreateAllLoading[section.key]) {
                                                                            alert('Another stage is currently creating files. Please wait for it to complete before starting a new stage.');
                                                                            return;
                                                                        }
                                                                        this.createAllA8Section(section.key);
                                                                    }} />
                                                            }
                                                            
                                                            {/* Download All button for completed files */}
                                                            {hasCompletedFiles && (
                                                                <Popup
                                                                    trigger={
                                                                        <Button
                                                                            size='mini'
                                                                            basic
                                                                            color='blue'
                                                                            icon='download'
                                                                            content={`Download (${completedFiles.length})`}
                                                                            onClick={() => this._downloadA8Section(section.key, completedFiles)}
                                                                        />
                                                                    }
                                                                    content={`Download ${completedFiles.length} completed ${section.key} file(s) as ZIP`}
                                                                />
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                            {sectionLocked && (
                                                <Message size='tiny' warning content={section.key === 'store'
                                                    ? 'Store creation is enabled only after all Seller files succeed.'
                                                    : 'Plan creation is enabled only after all Store files succeed.'} />
                                            )}
                                            <Table compact celled>
                                                <Table.Header>
                                                    <Table.Row>
                                                        <Table.HeaderCell>File</Table.HeaderCell>
                                                        <Table.HeaderCell>Status</Table.HeaderCell>
                                                        <Table.HeaderCell>Actions</Table.HeaderCell>
                                                    </Table.Row>
                                                </Table.Header>
                                                <Table.Body>
                                                    {files.map((file, idx) => {
                                                        const loadingKey = `${section.key}-${idx}`;
                                                        const loading = this.state.a8CreateLoading[loadingKey];
                                                        const state = (file.state || 'pending').toLowerCase();

                                                        return (
                                                            <Table.Row key={loadingKey}>
                                                                <Table.Cell>{file.sourceName || `file_${idx + 1}.xlsx`}</Table.Cell>
                                                                <Table.Cell>{this._a8StatusBadge(state)}</Table.Cell>
                                                                <Table.Cell>
                                                                    {(state !== 'success' || section.key === 'planning') && (
                                                                        <Popup
                                                                            trigger={
                                                                                <Button
                                                                                    size='mini'
                                                                                    basic
                                                                                    color={state === 'error' ? 'orange' : (state === 'success' ? 'teal' : 'green')}
                                                                                    content={state === 'error' ? 'Retry' : (state === 'success' ? 'Re-Upload' : 'Upload')}
                                                                                    loading={loading}
                                                                                    disabled={loading || state === 'creating' || state === 'processing' || sectionLocked || isAnyUploadRunning}
                                                                                    onClick={() => {
                                                                                        if (state === 'success') {
                                                                                            if (!window.confirm('This file was already uploaded successfully. Are you sure you want to re-upload?')) return;
                                                                                        }
                                                                                        // Collision detection: warn if another stage is creating
                                                                                        if (isCreateAllRunning && !this.state.a8CreateAllLoading[section.key]) {
                                                                                            alert('Another stage is currently creating files. Please wait for it to complete before manually creating a file.');
                                                                                            return;
                                                                                        }
                                                                                        this.createA8File(section.key, idx);
                                                                                    }}
                                                                                />
                                                                            }
                                                                            content={isCreateAllRunning && !this.state.a8CreateAllLoading[section.key] ? 'Another stage is creating files. Please wait.' : ''}
                                                                        />
                                                                    )}
                                                                    {file.outputDownloadUrl && (
                                                                        <a href={file.outputDownloadUrl} target='_blank' rel='noreferrer' style={{ marginLeft: 6 }}>
                                                                            <Button size='mini' basic color='blue' content='Download' />
                                                                        </a>
                                                                    )}
                                                                    {file.errorReportUrl && (
                                                                        <a href={file.errorReportUrl} target='_blank' rel='noreferrer' style={{ marginLeft: 6 }}>
                                                                            <Button size='mini' basic color='red' content='Error Report' />
                                                                        </a>
                                                                    )}
                                                                    {file.lastError && (
                                                                        <Popup
                                                                            trigger={<Icon name='warning sign' color='red' style={{ marginLeft: 8, cursor: 'pointer' }} />}
                                                                            content={file.lastError}
                                                                        />
                                                                    )}
                                                                </Table.Cell>
                                                            </Table.Row>
                                                        );
                                                    })}
                                                    {files.length === 0 && (
                                                        <Table.Row>
                                                            <Table.Cell colSpan={3} textAlign='center' style={{ color: '#aaa' }}>No files found.</Table.Cell>
                                                        </Table.Row>
                                                    )}
                                                </Table.Body>
                                            </Table>
                                        </div>
                                    );
                                })}
                            </>
                        )}
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={this.closeA8CreateModal}>Close</Button>
                    </Modal.Actions>
                </Modal>

                {/* ── History Modal — disabled ──────────────────────────── */}
                {/* <Modal open={historyModalOpen} onClose={() => this.setState({ historyModalOpen: false })} size='large'>
                    <Modal.Header>
                        <Icon name='history' /> Output History — {historyDistributor}
                    </Modal.Header>
                    <Modal.Content scrolling>
                        {historyData.length === 0
                            ? <p style={{ color: '#aaa' }}>No history available.</p>
                            : historyData.map((h, i) => {
                                const srcStore  = (h.inputSource || {}).storeMaster;
                                const srcSeller = (h.inputSource || {}).sellerMaster;
                                return (
                                    <div key={i} style={{ borderBottom: '1px solid #eee', paddingBottom: 12, marginBottom: 12 }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                                            <strong>Run {historyData.length - i}</strong>
                                            <Label size='mini' color={h.status === 'Completed' ? 'green' : 'red'}>{h.status}</Label>
                                            <span style={{ color: '#888', fontSize: '0.85em' }}>{h.createdAt}</span>
                                            <span style={{ fontSize: '0.8em', color: '#aaa' }}>
                                                by {typeof h.triggeredBy === 'object' ? (h.triggeredBy?.siteName || 'system') : (h.triggeredBy || 'system')}
                                            </span>
                                            {srcStore  && <Label size='mini' color={srcStore  === 'user' ? 'blue' : 'grey'}>SM: {srcStore}</Label>}
                                            {srcSeller && <Label size='mini' color={srcSeller === 'user' ? 'blue' : 'grey'}>Sell: {srcSeller}</Label>}
                                        </div>
                                        <div style={{ marginTop: 8, display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                                            {this._dlList(h.storeMaster, 'SM')}
                                            {this._dlList(h.sellerMaster, 'Sell')}
                                            {this._dlList(h.planning, 'Plan')}
                                            {h.storeMasterValidated && this._dlBtn(h.storeMasterValidated, 'Validated')}
                                            {h.errorReport && this._dlBtn(h.errorReport, 'Error')}
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={() => this.setState({ historyModalOpen: false })}>Close</Button>
                    </Modal.Actions>
                </Modal> */}
            </>
        );
    }
}

const mapStateToProps = (state) => ({ auth: state.auth });

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getSsmInputs, getSsmDistributors, runsmsmAutomation,
    runSsmAllDistributors, getsmsmAutomationStatus,
    getSsmOutputHistory, downloadSsmAll, downloadSsmRowOutputs, rawFileProcess,
    uploadSsmDistributorFile, getSsmA8Status, createSsmA8File, setSsmA8CreateAllRunning,
    runSsmValidationConsole, downloadSsmValidationConsole,
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SMSMAutomation));
